<template>
  <div class="d-none d-md-block" v-if="desktop">
    <GoogleAdsPopup
      path="/22163595876/RTBGo_Interstitial_Web"
      :size="[1, 1]"
      id="RTBGo_Interstitial_Web"
      style="margin:0 auto;"
    />
  </div>
</template>

<script>
/* eslint-disable */
// import PopupInterstitial from "../ads/popupInterstitial";
import GoogleAdsPopup from "./googleAdsPopup.vue";
export default {
  data() {
    return {
      mobile: false,
      desktop: false,
    };
  },
  components: {
    GoogleAdsPopup,
  },
  methods: {
    deviceCheck() {
      if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
  },
  mounted() {
    this.deviceCheck();
  },
};
</script>
<style scoped></style>
